import { SEO } from '@config';
import { t } from '@utils/i18n';

const getTags = ({ page = '', title, description, robots, city, address }) => {
  const config = {
    bestsellerPreset: {
      title: t('seo.preset.bestseller.title', { replacements: { title } }),
      description: t('seo.preset.bestseller.description', { replacements: { title } }),
    },
    preorderPreset: {
      title: t('seo.preset.preorder.title', { replacements: { title } }),
      description: t('seo.preset.preorder.description', { replacements: { title } }),
    },
    recentPreset: {
      title: t('seo.preset.recent.title', { replacements: { title } }),
      description: t('seo.preset.recent.description', { replacements: { title } }),
    },
    allPreset: {
      title: t('seo.preset.all.title', { replacements: { title } }),
      description: t('seo.preset.all.description', { replacements: { title } }),
      robots: 'noindex',
    },
    search: {
      title: t('seo.search.title', { replacements: { title } }),
      robots: 'noindex',
    },
    pdp: {
      title,
      description: `${description} ${SEO.descriptionAppendix}`,
    },
    category: {
      title,
      description: `${description} ${SEO.descriptionAppendix}`,
    },
    storeFinder: {
      title: t('seo.storefinder.title'),
      description: t('seo.storefinder.description'),
    },
    blogOverview: {
      title: t('seo.blogoverview.title'),
      description: t('seo.blogoverview.description'),
    },
    blogList: {
      title: t('seo.bloglist.title'),
      description: t('seo.bloglist.description'),
    },
    campaign: {
      title: title || t('seo.campaign.default.title'),
      description: description || t('seo.campaign.default.description'),
      robots,
    },
    entity: {
      title: t('seo.entity.title', { replacements: { title } }),
      description: `${t('seo.entity.description', { replacements: { title } })} ${SEO.descriptionAppendix}`,
    },
    storePage: {
      title,
      description: t('seo.storePage.description', { replacements: { city, address } }),
    },
    dashboardPage: {
      title: t('seo.dashboardPage.title'),
    },
  };
  return config[page] || { title, description, robots };
};

export default getTags;
